import { useMemo } from "react";
import { TellescopeFormFieldBaseProps } from "../../types";
import { InputTableRow } from "./InputTableRow";
import { TableInputCell } from "@tellescope/types-models";
import { cn } from "@tellescope/utils";
import { Button } from "@tellescope/ui";
import { useTranslation } from "react-i18next";

export interface InputTableFieldProps extends TellescopeFormFieldBaseProps<"Input Table"> {}

export const InputTableField = ({ id, title, value, onChange, className, options }: InputTableFieldProps) => {
  const { t } = useTranslation("forms");
  const columnsConfig = options?.tableChoices;
  const emptyRow = useMemo<TableInputCell[]>(() => {
    return (
      columnsConfig?.map((columnConfig) => ({
        label: columnConfig.label,
        entry: "",
      })) ?? []
    );
  }, [columnsConfig]);

  if (!columnsConfig?.length) {
    return null;
  }

  const normalizedValue = value?.length ? value : [emptyRow];

  return (
    <div>
      {!!title && <h4>{title}</h4>}
      <div className={cn(`flex flex-col gap-1`, className)}>
        {normalizedValue.map((row, i) => (
          <InputTableRow
            key={`input-table-row-${title ?? ""}-${i}`}
            fieldId={id}
            value={row}
            columnsConfig={columnsConfig}
            onChange={(row) => onChange([...normalizedValue.slice(0, i), row, ...normalizedValue.slice(i + 1)])}
            onRemove={
              normalizedValue?.length === 1
                ? undefined
                : () => onChange([...normalizedValue.slice(0, i), ...normalizedValue.slice(i + 1)])
            }
          />
        ))}
        <div className="flex justify-end mt-1">
          <Button
            variant="outline"
            onClick={() => (value?.length ? onChange([...(value ?? []), emptyRow]) : onChange([emptyRow, emptyRow]))}
          >
            {t("Add New Entry")}
          </Button>
        </div>
      </div>
    </div>
  );
};
